import * as React from "react";

// Sidebar/app-shell compact breakpoint.
// Below this width the persistent desktop sidebar is replaced with an
// off-canvas (Sheet) overlay so page content gets the full viewport width.
// Intentionally separate from useIsMobile (768px) which other components rely on.
const SIDEBAR_COMPACT_BREAKPOINT = 1024;

export function useIsSidebarCompact() {
  const [isCompact, setIsCompact] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${SIDEBAR_COMPACT_BREAKPOINT - 1}px)`);
    const onChange = () => setIsCompact(window.innerWidth < SIDEBAR_COMPACT_BREAKPOINT);
    mql.addEventListener("change", onChange);
    setIsCompact(window.innerWidth < SIDEBAR_COMPACT_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isCompact;
}
